// defs
import type { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";
import { CardPaymentMethodMeta } from "@swiggy-private/payment-ui";

// constants
import {
    PaymentMethod,
    PaymentMethodMeta,
    VALID_PAYMENT_GROUP_TYPES,
    VALID_PAYMENT_METHODS,
} from "@swiggy-private/payment-types";
import { Some, None } from "@swiggy-private/js-fp";
import { getPaymentGroup } from "@payment-client/helpers/PaymentHelper";

export const getPaymentMethod = ({
    cardReference,
    paymentResponse,
}: {
    cardReference?: string | null;
    paymentResponse?: GetPaymentMethodsResponse | null;
}) => {
    if (!cardReference || !paymentResponse) {
        return None;
    }

    const paymentMethodsCard = getPaymentGroup(paymentResponse, VALID_PAYMENT_METHODS.CARD)?.paymentMethods || [];
    const paymentMethodsPreferred =
        getPaymentGroup(paymentResponse, VALID_PAYMENT_GROUP_TYPES.PREFERRED)?.paymentMethods || [];

    const finalList = paymentMethodsCard.concat(paymentMethodsPreferred);
    const paymentMethod = finalList.find((pm: PaymentMethod<PaymentMethodMeta>) => {
        const { cardReference: metaCardReference } = pm.meta as CardPaymentMethodMeta;
        return cardReference === metaCardReference;
    });

    if (!paymentMethod) {
        return None;
    }

    return Some(paymentMethod);
};

export const isCvvMandatory = ({
    cardReference,
    paymentResponse,
}: {
    cardReference?: string | null;
    paymentResponse?: GetPaymentMethodsResponse | null;
}) => {
    const paymentMethod = getPaymentMethod({ cardReference, paymentResponse });
    if (!paymentMethod.isSome()) {
        return false;
    }

    const { cvvMandatory } = paymentMethod.unwrap().meta || {};
    return cvvMandatory;
};
